var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIgicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 0C2.99067 0 0 2.99067 0 6.66667V17.3333C0 21.0093 2.99067 24 6.66667 24H17.3333C21.0093 24 24 21.0093 24 17.3333V6.66667C24 2.99067 21.0093 0 17.3333 0H6.66667ZM6.66667 2.66667H17.3333C19.5387 2.66667 21.3333 4.46133 21.3333 6.66667V17.3333C21.3333 19.5387 19.5387 21.3333 17.3333 21.3333H6.66667C4.46133 21.3333 2.66667 19.5387 2.66667 17.3333V6.66667C2.66667 4.46133 4.46133 2.66667 6.66667 2.66667ZM18.6667 4C18.313 4 17.9739 4.14048 17.7239 4.39052C17.4738 4.64057 17.3333 4.97971 17.3333 5.33333C17.3333 5.68696 17.4738 6.02609 17.7239 6.27614C17.9739 6.52619 18.313 6.66667 18.6667 6.66667C19.0203 6.66667 19.3594 6.52619 19.6095 6.27614C19.8595 6.02609 20 5.68696 20 5.33333C20 4.97971 19.8595 4.64057 19.6095 4.39052C19.3594 4.14048 19.0203 4 18.6667 4ZM12 5.33333C8.324 5.33333 5.33333 8.324 5.33333 12C5.33333 15.676 8.324 18.6667 12 18.6667C15.676 18.6667 18.6667 15.676 18.6667 12C18.6667 8.324 15.676 5.33333 12 5.33333ZM12 8C14.2053 8 16 9.79467 16 12C16 14.2053 14.2053 16 12 16C9.79467 16 8 14.2053 8 12C8 9.79467 9.79467 8 12 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgicon);
export default __webpack_public_path__ + "static/media/ig icon.12fcbac5320a3d915d418104b7c4d07d.svg";
export { ForwardRef as ReactComponent };